const map = {
	"./award-cream copy.png": 8171,
	"./award-cream.png": 1202,
	"./award-gold.png": 7052,
	"./award-green copy.png": 1470,
	"./award-green.png": 8745,
	"./bolt-cream copy.png": 1855,
	"./bolt-cream.png": 7110,
	"./bolt-gold.png": 2168,
	"./bolt-green copy.png": 6002,
	"./bolt-green.png": 8317,
	"./book-cream copy.png": 9605,
	"./book-cream.png": 6288,
	"./book-gold.png": 8678,
	"./book-green copy.png": 6308,
	"./book-green.png": 7275,
	"./check-cream copy.png": 2070,
	"./check-cream.png": 113,
	"./check-gold copy.png": 6998,
	"./check-gold.png": 5505,
	"./check-green copy.png": 4587,
	"./check-green.png": 2994,
	"./eye-cream.png": 462,
	"./eye-green.png": 4277,
	"./globe-cream.png": 7474,
	"./globe-green.png": 825,
	"./image-cream.png": 9738,
	"./image-green.png": 6513,
	"./layout-cream.png": 173,
	"./layout-green.png": 6622,
	"./pencil-cream.png": 4788,
	"./pencil-green.png": 8479,
	"./phone-cream.png": 2085,
	"./phone-green.png": 1398,
	"./shield-cream.png": 9996,
	"./shield-green.png": 9911,
	"./target-cream.png": 2680,
	"./target-green.png": 5555,
	"./trend-cream.png": 2316,
	"./trend-green.png": 8295,
	"./users-cream.png": 1381,
	"./users-green.png": 2950
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1095;